import React, { useState, useEffect } from 'react';


function MapData({year}) {

    // useEffect(() => {
    //     var url = "airport_movement_by_region/" + year;

    //     fetch(url).then((res) =>
    //         res.json().then((res) => {
    //             console.log("Hey from Maps")
    //             console.log("Result" ,res)
    //     })
    //     )
    //     .catch((error) => {
    //     console.log("Refetching data for Maps!")
    //     });
    // }, [year]);


    return(
      <></>
    );
}



export default MapData;
